// Every request an embed frame sends to Indee (#2039, design D2). The server
// reads the frame's own cookie and forgery token only for a request carrying
// this header, so a page or a link asking for JSON never acts as the frame.
export const FRAME_HEADER = "X-Indee-Embed"

export type FrameRequestInit = Omit<RequestInit, "headers"> & {
  headers?: Record<string, string>
}

export function frameFetch(
  url: string,
  init: FrameRequestInit = {},
): Promise<Response> {
  return fetch(url, {
    credentials: "same-origin",
    ...init,
    headers: {
      Accept: "application/json",
      ...init.headers,
      [FRAME_HEADER]: "1",
    },
  })
}
